import showModalNotificationError from '@v2/commons/modals/ModalNotification/showModalNotificationError'

export const handleMutationError = (
  err: any,
  defaultMessage: string,
  onClickBtn?: () => void,
  buttonText = 'retry',
) => {
  let errorMessage = err?.data?.message || err?.data?.error || defaultMessage
  if (Array.isArray(errorMessage)) {
    errorMessage = errorMessage.join(', ')
  }
  showModalNotificationError({
    subtitle: errorMessage,
    buttonText,
    onClickBtn: onClickBtn ? onClickBtn : () => null,
  })
  return false
}
